export default __webpack_public_path__ + "static/media/footerimg2.1cc94bac.png";